import React from "react";
import { Route } from "react-router-dom";
import ReportingRoutes from "./Reporting/routes";
import CDR from "./CDR/routes";
import INBOUND from "./Inbound/routes";
import VoiceCdr from "./VoiceCdr/routes";
import VoiceAPiCdr from "./VoiceAPiCdr/routes";
import BreakReport from "./BreakReport/routes";
import UserSummery from "./UserSummery/routes";
import HourlyReport from "./HourlyReport/routes";
import HourlyInbound from "./HourlyInbound/routes";
import DesposeReport from "./DesposeReport/routes";
import GenericVoiceCDR from "./genricVoiceCDR/routes";
import CallBackReport from "./CallBackReport/routes";
import IVRReport from "./IVRReport/routes";
import WebhooksReport from "./WebhooksReport/routes";
import TeamSummary from "./TeamSummary/routes";
import CampaignSummary from "./CampaignSummary/routes";
import AgentHeatMap from "./AgentHeatMap/routes";
import ContactListCallStatistics from "./ContactListCallStatistics/routes";
import AgentAutoDisposeSummary from "./AgentAutoDisposeSummary/routes";
import AgentCareerStatus from "./AgentCareerStatus/routes";
import ContactListQualityAssurance from "./ContactListQualityAssurance/routes";
import CommonAgentReports from "./CommonAgentReports/routes";
import ProviderSummary from "./ProviderSummary/routes";
import CarrierStatusSummary from "./CarrierStatusSummary/routes";
import CallReport from "./CallReport/routes";
import MessageCDRReport from "./MessageCDRReport/routes";
import CommonMsgReports from './CommonMsgReports/routes';

const routes = () => [
  <ReportingRoutes key="ReportingRoutes" />,
  <CallReport key="CallReport" />,
  <MessageCDRReport key="MessageCDRReport" />,
  <CommonMsgReports key="CommonMsgReports" />,
  <CDR key="CDR" />,
  <INBOUND key="INBOUND_CDR" />,
  <VoiceCdr key="VoiceCdr" />,
  <VoiceAPiCdr key="VoiceAPiCdr" />,
  <BreakReport key="BreakReport" />,
  <UserSummery key="UserSummery" />,
  // <HourlyReport key="HourlyReport" />,
  <IVRReport key="IVRReport" />,
  <HourlyReport key="HourlyReport" />,
  /* <HourlyInbound key="HourlyInbound" />, */
  <DesposeReport key="DesposeReport" />,
  <GenericVoiceCDR key="genericVoiceCDR" />,
  <CallBackReport key="CallBackReport" />,
  <WebhooksReport key="WebhooksReport" />,
  <ContactListCallStatistics key="ContactListCallStatistics" />,
  <ContactListQualityAssurance key="ContactListQualityAssurance" />,
  <AgentHeatMap key="AgentHeatMap" />,
  <AgentAutoDisposeSummary key="AgentAutoDisposeSummary" />,
  <AgentCareerStatus key="AgentCareerStatus" />,
  <CommonAgentReports key="CommonAgentReports" />,
  <ProviderSummary key="ProviderSummary" />,
  <CarrierStatusSummary key="CarrierStatusSummary" />,
];

const ReportingRoute = () => <Route component={routes} />;

export default ReportingRoute;



// WEBPACK FOOTER //
// src/modules/screens/reporting/routes.js